import axios from '../utils/axios';
import { CalibrationParameters } from '../types/CalibrationParameters';

export async function updateConfig(configId: string, data: any): Promise<any> {
  return axios.put(`/configs/${configId}`, data).then((res) => res.data);
}

/**
 * Partial update: only the keys present in `data` are written, so the caller
 * sends what changed rather than a whole round-tripped config. An explicit
 * `null` still writes NULL — that is how the calibration form clears a value
 * back to inherited — while an absent key leaves the stored value alone.
 */
export async function patchConfig(configId: string, data: any): Promise<any> {
  return axios.patch(`/configs/${configId}`, data).then((res) => res.data);
}

export async function createConfig(data: any): Promise<any> {
  return axios.post('/configs', data).then((res) => res.data);
}

export async function deleteConfig(configId: string): Promise<any> {
  return axios.delete(`/configs/${configId}`).then((res) => res.data);
}

export async function getConfig(configId: string, scope?: string): Promise<CalibrationParameters> {
  const queryString = scope ? `?scope=${scope.toString()}` : '';
  return axios.get(`/configs/${configId}${queryString}`).then((res) => res.data);
}

export async function getConfigs(calibrationIds?: string[]): Promise<any[]> {
  const queryString = calibrationIds && calibrationIds.length > 0 ? `?id=${calibrationIds.join(',')}` : '';
  return axios.get(`/configs${queryString}`).then((res) => res.data);
}

export async function batchUpdateConfigs(configs: any[]): Promise<any> {
  return axios.put('/configs', configs).then((res) => res.data);
}

/** Batch partial update — per-body narrow writes. See `patchConfig`. */
export async function batchPatchConfigs(configs: any[]): Promise<any> {
  return axios.patch('/configs', configs).then((res) => res.data);
}
